import { render, staticRenderFns } from "./AgendaLinkPatient.vue?vue&type=template&id=4ff193cd&scoped=true"
import script from "./AgendaLinkPatient.vue?vue&type=script&lang=js"
export * from "./AgendaLinkPatient.vue?vue&type=script&lang=js"
import style0 from "./AgendaLinkPatient.vue?vue&type=style&index=0&id=4ff193cd&prod&scoped=true&lang=css"
import style1 from "./agendaDialogs.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff193cd",
  null
  
)

export default component.exports